'use strict';

/**
 * Removes the first occurrence of a specified value from an array.
 *
 * @template T - The type of elements in the array.
 * @param {T[]} arr - The array from which to remove the value.
 * @param {T} value - The value to remove from the array.
 * @returns {T[]} - A new array with the value removed, or the original array if the value was not found.
 */ function removeItemOnce(arr, value) {
    const index = arr.indexOf(value);
    if (index > -1) {
        arr.splice(index, 1);
    }
    return arr;
}

module.exports = removeItemOnce;
